export enum ListConfigAccount {
  SipTrunk,
  User,
  ExportFilter,
}
export class AccountConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên tài khoản',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Domain',
        key: 'domain',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Hoạt động',
        key: 'display_active',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static displayActiveColumn = data => {
    if (data.active) {
      return `<span class="text-success"><i class="icon fa fa-check-square-o" aria-hidden="true" style="font-size: 24px"></i></span>`;
    } else {
      return `<span class="text-secondary"><i class="icon fa fa-check-square-o" aria-hidden="true" style="font-size: 24px"></i></span>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/account/account.const.ts